import { APP_COLORS } from "../../../../enums";

export const ENVIRONMENT_LIST = [
  {
    label: "AWS",
    field: "aws",
    value: 0,
    color: APP_COLORS.successDark,
  },
  {
    label: "GCP",
    field: "gcp",
    value: 0,
    color: APP_COLORS.infoDark,
  },
  {
    label: "Azure",
    field: "azure",
    value: 0,
    color: APP_COLORS.secondaryDark,
  },
  {
    label: "Other",
    field: "other",
    value: 0,
    color: APP_COLORS.yellowDark,
  },
  {
    label: "On Prem",
    field: "onPrem",
    value: 0,
    color: APP_COLORS.errorDark,
  },
];
